import React from 'react';
import { Switch } from '@headlessui/react';
import { cn } from '@/lib/utils';
import { useAHUControl } from '@/contexts/ahu-control-context';

export function OperationControl({ onChange }) {
  // No need to call onChange - we just want to display Remote visually
  // The component is purely visual now and doesn't trigger any API calls

  return (
    <div className="px-2 pt-[6px] pb-[10px] bg-bg rounded-lg border border-light-grey flex flex-col gap-1 justify-between">
      <div className="text-dark-blue heading-7">Operation</div>
      <div className='flex items-center gap-1.5'>
        <p className="paragraph-11 text-dark-grey">Manual</p>
        <div className="relative inline-flex h-4 w-8 items-center rounded-full bg-gradient-to-r from-primary to-green opacity-50 cursor-not-allowed">
          <span className="inline-block h-3 w-3 transform rounded-full bg-white transition translate-x-4" />
        </div>
        <span className="paragraph-11 text-primary">Remote</span>
      </div>
    </div>
  );
}